<template>
<div class="error-container">
    <div class="icon-container mb-3 mt-3">
        <i class="fas fa-exclamation-triangle"></i>
    </div>
    <div class="notify-text">
        <p>
            <!--Message slot-->
            <slot></slot>
        </p>
    </div>
</div>
</template>

<script>
    export default {
        name: "ErrorBlock",
        props: {
            gaEvent: {
                type: String,
                default: null,
            }
        },
        mounted() {
            if (this.gaEvent) {
                sendGAEvent(this.gaEvent);
            }
        }
    }
</script>

<style lang="scss" scoped>
.error-container {
    .icon-container {
        font-size: 10rem;
        color: #fa6657;
    }

    i {
        display: flex;
        justify-content: center;
    }
}

.notify-text {
    display: flex;
    justify-content: center;
    padding: 0 20% 0;
}
</style>
